import { TESTER_PRICE } from '../../const/project';



export default (taskTime) => {
  const minutesPerHour = 60;

  return ((TESTER_PRICE.PRICE * taskTime) / minutesPerHour).toFixed(2);
};
